import { render } from "./reqManage.vue?vue&type=template&id=744bcd83&scoped=true"
import script from "./reqManage.vue?vue&type=script&lang=js"
export * from "./reqManage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744bcd83"]])

export default __exports__